import { FC } from 'react'
import shallow from 'zustand/shallow'
import { Tabs, Cascader } from 'antd'
import { useTranslation } from 'react-i18next'
import { RoleName } from '../../types'
import { EmployeeTabs } from './types'
import { PerTabBarContent } from '../../components/custom_components/TabBarContent'
import { useEmployeeStore } from './EmployeeStore'
import { useUserManagersRolesByCompany } from '../../graphql/company/hooks/useUserManagerRolesByCompany'
import { searchOptionsFilter } from '../../components/custom_components/Cascader/util'
import { useCascaderSearchOnOpen } from '../../components/custom_components/Cascader/useCascaderSearchOnOpen'

const { TabPane } = Tabs

export const EmployeeHeader: FC = () => {
  const { t } = useTranslation()

  const [activeTab, setActiveTab, companiesAndBuSelected, selected, setSelected] = useEmployeeStore(
    (state) => [state.activeTab, state.setActiveTab, state.companiesAndBuSelected, state.selected, state.setSelected],
    shallow,
  )

  const { cascaderRef, cascaderClassName, searchPlaceholder, onPopupVisibleChange } = useCascaderSearchOnOpen(
    t('companySettingsView.companyOrBusinessUnitCascaderSearchPlaceholder'),
  )

  const { data: userRolesData } = useUserManagersRolesByCompany(selected.companyId)
  const userRoles: RoleName[] =
    userRolesData && userRolesData.findUserManagerRolesByCompany ? userRolesData.findUserManagerRolesByCompany : []
  const isCompanyManager = userRoles.includes(RoleName.CompanyManager)
  const isBusinessPartner = userRoles.includes(RoleName.BusinessPartner)
  const resignedTabVisible = isBusinessPartner || isCompanyManager

  if (!resignedTabVisible) {
    setActiveTab(EmployeeTabs.Active)
  }

  const onDropDownChanged = (values: string[]) => {
    if (!!values && values.length === 2) {
      setSelected(values[0], values[1])
    }
  }

  return (
    <PerTabBarContent
      tabs={
        <>
          {resignedTabVisible && (
            <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key as EmployeeTabs)}>
              <TabPane tab={t('global.employeeCompanyRelation.active')} key={EmployeeTabs.Active} />
              <TabPane tab={t('global.employeeCompanyRelation.resigned')} key={EmployeeTabs.Resigned} />
            </Tabs>
          )}
        </>
      }
      actions={
        <Cascader
          ref={cascaderRef}
          className={cascaderClassName}
          options={companiesAndBuSelected}
          onChange={onDropDownChanged}
          placeholder={searchPlaceholder}
          allowClear={false}
          defaultValue={[selected.companyId, selected.buId]}
          value={[selected.companyId, selected.buId]}
          style={{ width: '460px', marginLeft: '3.5px' }}
          showSearch={{ filter: searchOptionsFilter }}
          onPopupVisibleChange={onPopupVisibleChange}
        />
      }
    />
  )
}
